<template>
  <DataTable url="security" />
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "role-index",
  emits: ["setBreadcrumb"],
  components: { DataTable },
  data() {
    return {
      breadcrumb: [{ text: "Cuarentena", link: { name: "quarantine" } }],
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
